import { render, staticRenderFns } from "./ModalSelectPageFacebook.vue?vue&type=template&id=62352d53&scoped=true&"
import script from "./ModalSelectPageFacebook.vue?vue&type=script&lang=js&"
export * from "./ModalSelectPageFacebook.vue?vue&type=script&lang=js&"
import style0 from "./ModalSelectPageFacebook.vue?vue&type=style&index=0&id=62352d53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62352d53",
  null
  
)

export default component.exports